import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiClient } from "../../app/helper/axiosHelper";
import { ApiConstants } from "../../app/utils/apis/ApiConstants";
import { showErrorResponse } from "../../app/utils/common/showErrorMessage";

export const getAllUsersAPI = createAsyncThunk(
  "getAllUsers/getAllUsersAPI",
  async (
    {
      page,
      total_page = 10,
      role_id,
      searchText = "",
      // is_delete,
      filterBy
    }: {
      page: number;
      total_page?: number;
      role_id: number;
      searchText?: string;
      // is_delete?: boolean
      filterBy: string
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await apiClient.get(
        `${ApiConstants.GET_ALL_USERS}/?page=${page}&searchText=${searchText ?? ""}&limit=${total_page}&role_id=${role_id}&filterBy=${filterBy}`
      );
      return {
        user_data: response.data.data.user_data,
        pagination: response.data.data.pagination,
        role_id: role_id,
        filterBy: filterBy,
        // is_delete: is_delete
      };
    } catch (err: any) {
      return rejectWithValue(err.response.data.error);
    }
  }
);


export const getAllUserManagementAPI = createAsyncThunk(
  "getAllUsers/getAllUserManagementAPI",
  async (
    {
      page,
      total_page,
      searchText = "",
      sortBy,
      role_id,
      limit,
      filterBy
    }: {
      page: number;
      total_page?: number;
      searchText?: string;
      role_id?: number;
      limit?: number;
      sortBy?: any;
      filterBy?: any;
    },
    { rejectWithValue }
  ) => {
    const paramsPayload: any = {
      page: page,
      searchText: searchText,
      role_id: role_id,
      limit: total_page,
      filterBy: filterBy,
    }
    if (sortBy && sortBy > 0) {
      paramsPayload.role_id = sortBy
    }
    try {
      const response = await apiClient.get(ApiConstants.GET_ALL_USERS, {
        params: paramsPayload
      })

      return {
        user_data: response.data.data.user_data,
        pagination: response.data.data.pagination,
      };
    } catch (err: any) {
      return rejectWithValue(err.response.data.error);
    }
  }
);


//create user
export const createUserAPI = createAsyncThunk(
  "user/createManager",
  async (
    data: {
      role_id: number;
      name: string;
      country_code: string;
      phone_number: string;
      profile_image?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await apiClient.post(
        `${ApiConstants.CREATE_USER}`,
        data
      );
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data.error);
    }
  }
);

//update user
export const updateUserAPI = createAsyncThunk(
  "user/updateUserAPI",
  async (
    data: {
      user_id: number;
      name?: string;
      country_code?: string;
      phone_number?: string;
      profile_image?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      let { user_id, ...reqObj } = data;
      const response = await apiClient.put(
        `${ApiConstants.UPDATE_USER}/${user_id}/update`,
        reqObj
      );
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error);
    }
  }
);

export const deleteUserAPI = createAsyncThunk(
  "user/deleteUserAPI",
  async (data: { user_id: number }, { rejectWithValue }) => {
    try {
      const response = await apiClient.delete(
        `${ApiConstants.DELETE_USER}/${data.user_id}/delete`
      );
      return
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error);
    }
  }
);

export const excellDownloadUserAPI = createAsyncThunk(
  "user/excellDownloadUserAPI",
  async (data: { role_id: number }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`${ApiConstants?.DOWNLOAD_USER_EXCELL}?role_id=${data?.role_id}`);
      const job_id = response.data.data.job_id
      if (job_id) {
        const maxPollingTime = 90000;
        const pollingInterval = 2500;
        let timeSpent = 0;

        return new Promise((resolve, reject) => {
          const intervalId = setInterval(async () => {
            try {
              timeSpent = timeSpent + pollingInterval;

              const statusResponse = await apiClient.get(
                `${ApiConstants.EXPORT_DOWNLOAD_EXCELL_STATUS}/${job_id}/export-status`
              );

              if (statusResponse.data.data.status === "completed") {
                clearInterval(intervalId);
                resolve(statusResponse.data.data);  // Sends the successful response data to the caller
              } else if (timeSpent >= maxPollingTime) {
                clearInterval(intervalId);
                reject(new Error("Polling timed out after 1.5 minutes"));
              }
            } catch (err) {
              console.log('ERROR IN EXPORT DOWNLOAD EXCELL STATUS API: ', err);
              clearInterval(intervalId);
              reject(err);
            }
          }, pollingInterval);
        });
      }
    } catch (error: any) {
      console.log('Error in getting excellDownloadUserAPI :>> ', error);
      showErrorResponse(error.response.data.error);
      return rejectWithValue(error);
    }
  }
);